module.exports = __webpack_public_path__ + "static/media/equipment-rental.4ecfa85b.svg";